var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/captain-management/drivers"}},[_c('img',{attrs:{"src":require("@assets/images/logo.png"),"alt":"Logo","height":"35","width":"200"}})])}
var staticRenderFns = []

export { render, staticRenderFns }